/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
/*
MIT License

Copyright (c) 2018 Jim Gallagher

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import './TreeTable.css';

class TreeTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      enhancedTableData: this.generateStateTableData(this.props.tableData),
      expanded: false
    };
  }

  generateStateTableData(tree, n = 1) {
    return (function recurse(children, parent = 0, rowLevel = 1) {
      if (children) {
        return children.map((node) => {
          const rowID = n++;
          return {
            ...node,
            rowID,
            rowLevel,
            parentRowID: parent,
            visible: parent === 0,
            expanded: false,
            children: recurse(node.children, rowID, rowLevel + 1)
          };
        });
      }
    }(tree));
  }

  expandOrCollapseAll() {
    const { expanded, enhancedTableData } = this.state;
    const action = !expanded;
    const newTree = (function recurse(children) {
      return children.map((node) => {
        const visibleAction = node.rowLevel === 1 ? true : action;
        return {
          ...node,
          visible: visibleAction,
          expanded: action,
          children: recurse(node.children)
        };
      });
    }(enhancedTableData));
    this.setState({
      enhancedTableData: newTree,
      expanded: action
    });
  }

  rowExpandOrCollapse(selectedRowID) {
    const { enhancedTableData } = this.state;
    const newTree = this.expandOrCollapseTree(enhancedTableData, selectedRowID, false, false);
    this.setState({ enhancedTableData: newTree });
  }

  expandOrCollapseTree(data, selectedRowID, expandAll, collapseAll) {
    return (function recurse(children, expandBranch = expandAll, collapseBranch = collapseAll) {
      return children.map((node) => {
        let setExpanded = node.rowID === selectedRowID ? !node.expanded : node.expanded;
        let setVisible = node.parentRowID === selectedRowID ? !node.visible : node.visible;
        if (expandBranch) {
          setExpanded = true;
          setVisible = true;
        }
        if (collapseBranch) {
          setExpanded = false;
          setVisible = false;
        }
        //collapse and hide all below
        if (node.parentRowID === selectedRowID && !setVisible) {
          collapseBranch = true;
        }
        return {
          ...node,
          visible: setVisible,
          expanded: setExpanded,
          children: recurse(node.children, expandBranch, collapseBranch)
        };
      });
    }(data));
  }

  generateTableBody(tableData) {
    const tableBody = [];
    tableData.forEach((dataRow) => {
      const rowData = this.processDataRow(dataRow);
      const key = `${dataRow.parentRowID}-${dataRow.rowID}`;
      const rowClass = dataRow.visible ? 'shown' : 'hidden';
      tableBody.push(<tr className={rowClass} key={key}>{rowData}</tr>);
      if (dataRow.children) {
        tableBody.push(...this.generateTableBody(dataRow.children));
      }
    });
    return tableBody;
  }

  generateExpandColumn(dataRow, key, dataField) {
    if (dataRow.children && dataRow.children.length > 0) {
      let iconCell = (
        <FontAwesomeIcon
          icon={faAngleRight}
          fixedWidth
          onClick={this.rowExpandOrCollapse.bind(this, dataRow.rowID)}
        />
      );
      if (dataRow.expanded) {
        iconCell = (
          <FontAwesomeIcon
            icon={faAngleDown}
            fixedWidth
            onClick={this.rowExpandOrCollapse.bind(this, dataRow.rowID)}
          />
        );
      }
      if (this.props.columns[0].fixedWidth) {
        return (
          <td
            key={key}
            className={this.props.columns[0].styleClass}
            width={`${this.props.columns[0].percentageWidth}%`}
          >
            <span
              style={{ marginLeft: `${dataRow.rowLevel}em` }}
            >
              {iconCell}
              <span
                className="iconPadding"
              >
                {dataRow[dataField]}
              </span>
            </span>
          </td>
        );
      }
      return (
        <td key={key} className={this.props.columns[0].styleClass}>
          <span
            style={{ marginLeft: `${dataRow.rowLevel}em` }}
          >
            {iconCell}
            <span
              className="iconPadding"
            >
              {dataRow[dataField]}
            </span>
          </span>
        </td>
      );

    }
    if (this.props.columns[0].fixedWidth) {
      return (
        <td
          key={key}
          className={this.props.columns[0].styleClass}
          width={`${this.props.columns[0].percentageWidth}%`}
        >
          <span
            style={{ marginLeft: `${dataRow.rowLevel + 1.25}em` }}
          >
            <span className="iconPadding">{dataRow[dataField]}</span>
          </span>
        </td>
      );
    }
    return (
      <td key={key} className={this.props.columns[0].styleClass}>
        <span
          style={{ marginLeft: `${dataRow.rowLevel + 1.25}em` }}
        >
          <span className="iconPadding">{dataRow[dataField]}</span>
        </span>
      </td>
    );

  }

  processDataRow(dataRow) {
    const rowBody = [];
    rowBody.push(this.props.columns.map((column, index) => {
      const key = `${dataRow.parentRowID}-${dataRow.rowID}-${index}`;
      let output = dataRow[column.dataField];
      if (column.renderer) {
        output = this.props.columns[index].renderer(dataRow, column.dataField);
      }
      if (index === 0) {
        return this.generateExpandColumn(dataRow, key, column.dataField);
      }
      if (column.fixedWidth) {
        return (
          <td
            key={key}
            className={column.styleClass}
            width={`${column.percentageWidth}%`}
          >
            {output}
          </td>
        );
      }
      return <td key={key} className={column.styleClass}>{output}</td>;

    }));
    return rowBody;
  }

  generateHeaderRow() {
    const headingRows = [];
    if (this.props.columns) {
      headingRows.push(this.props.columns.map((column) => {
        if (column.heading) {
          return <th key={column.heading}>{column.heading}</th>;
        }
        return <th key={column.dataField}>{column.dataField}</th>;

      }));
    }
    return headingRows;
  }

  render() {
    const headingRows = this.generateHeaderRow();
    const tableBody = this.generateTableBody(this.state.enhancedTableData);
    return (
      <div>
        <button
          type="button"
          onClick={this.expandOrCollapseAll.bind(this)}
          className={this.props.control.showButton ? this.props.control.buttonClasses : 'hidden'}
        >
          {this.state.expanded ? 'Collapse All' : 'Expand All'}

        </button>
        <table className={this.props.control.tableClasses}>
          <thead>
            <tr>
              {headingRows}
            </tr>
          </thead>
          <tbody>
            {tableBody}
          </tbody>
        </table>
      </div>
    );
  }
}

TreeTable.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.object,
      children: PropTypes.arrayOf(PropTypes.object)
    })
  ).isRequired,
  control: PropTypes.shape({
    tableClasses: PropTypes.string,
    buttonClasses: PropTypes.string,
    showButton: PropTypes.bool
  }),
  columns: PropTypes.arrayOf(PropTypes.shape({
    dataField: PropTypes.string.isRequired,
    heading: PropTypes.string,
    fixedWidth: PropTypes.bool,
    percentageWidth: PropTypes.number,
    styleClass: PropTypes.string,
    renderer: PropTypes.func
  }))
};

TreeTable.defaultProps = {
  tableData: [],
  control: {
    tableClasses: '',
    buttonClasses: '',
    showButton: false
  },
  columns: [{
    dataField: '',
    heading: '',
    fixedWidth: false,
    percentageWidth: 0,
    styleClass: '',
    renderer: null
  }]
};

export default TreeTable;
